<template>
    <div>
        <div class="px-6 pt-2 text-center mt-12">
            <h2 class="font-light">You do not have permission to access this page.</h2>
        </div>
    </div>
</template>

<script>
    export default {
        beforeMount() {
            this.$Progress.start();
        },
        mounted() {
            this.$Progress.finish();
        },
        methods: {
            
        },
        computed: {
            
        }
    }
</script>
